import React, { Component } from 'react';
import './App.css';
import './btncss.css';
import Main from './Components/Main';
import LottieAnimation from './assets/Animations/Lottie';
import animationData from './assets/Animations/light-bulb';
import { Footer } from './Components/footer';

document.addEventListener('contextmenu', event => event.preventDefault());
  

class App extends Component {
    constructor(props){
        super(props);
        this.state = {
            isLoading: true
        }
    }

    componentDidMount() {
        setTimeout(() => {
            this.setState({isLoading: false})
        }, 5000);
    }


    render(){
        return (
            this.state.isLoading ? 
                 <div className='mainAnimation'> 
                    <div id="hcon" style={{"width": "100%", "textAlign": "center"}}>
                        <h1 style={{"fontSize": "44px","fontFamily": "PhotographSignature", "padding": "4px", "textAlign": "center", "marginTop": "100px"}}>Himanshu Mahawar Photography</h1>
                    </div>
                    <LottieAnimation lotti={animationData} height={150} width={150} isloop={true}/>
                </div>
                :  
                <div>
                    <Main />
                    <Footer /> 
                </div>
                         
        );
    }
}


export default App;